export default __webpack_public_path__ + "static/media/paymnts.0ed7097e.svg";